import { render, staticRenderFns } from "./ReplyEditor.vue?vue&type=template&id=36310190&"
import script from "./ReplyEditor.vue?vue&type=script&lang=js&"
export * from "./ReplyEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReplyEditor.vue?vue&type=style&index=0&id=36310190&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports